import { useEffect } from 'react';

import { StudentProfile } from 'pages/students/components/StudentProfile/StudentProfile';
import { StudentDetailsContext } from 'pages/students/context/StudentsDefaultContext';
import { IntlProvider, LocalizationProvider } from '@progress/kendo-react-intl';
import { GMetrixLoader } from 'components/GMetrixLoader/GMetrixLoader';
import { useNotification } from 'app/notifications';
import { PageWithHeader } from 'components/layout';
import { helpContent } from 'pages/students/help';
import { KendoIntlProvider } from 'app/culture';
import { useContext } from 'components/Tabs';
import { useParams } from 'react-router-dom';
import { StudentApi } from 'apis/StudentApi';
import { useSuperState } from 'hooks';
import { useIntl } from 'react-intl';

import 'styles/global-styles.scss';
import 'styles/kendo-default-theme-with-overrides.scss';

export const StudentDetail = () => {

    const { id } = useParams();
    const studentId = Number(id);

    const [state, setState] = useSuperState({
        loading: true
    });

    const { open, pageContext } = useContext(StudentDetailsContext);
    const { formatMessage, locale } = useIntl();
    const { createToast } = useNotification();

    const loadStudent = async () => {

        try {

            setState({ loading: true });
            const studentWithDetails = await StudentApi.Get(studentId);
            open({
                Data: { studentWithDetails, studentWithDetailsOriginal: studentWithDetails },
                HasChanges: false,
                Id: studentWithDetails.Id,
                Page: 'Students',
                Title: `${studentWithDetails.Fullname}`
            });
            setState({ loading: false });

        } catch (e) {

            console.error(e);
            createToast(formatMessage({ id: 'student_was_not_found_please_try_searchi.3844c677', defaultMessage: '{student} was not found, please try searching again' }, { student: String(studentId) }), 'danger');
            setState({ loading: false });

        }

    };

    useEffect(() => {

        loadStudent();

    }, [studentId]);

    return (
        <KendoIntlProvider>
            <LocalizationProvider language={locale}>
                <IntlProvider locale={locale}>
                    <div className={'student-detail d-flex flex-column gap-3'}>
                        {state.loading || !pageContext ?
                            (
                                <div className={'d-flex align-items-center justify-content-center'}>
                                    <GMetrixLoader />
                                </div>
                            )
                            :
                            (
                                <PageWithHeader
                                    headerConfig={{
                                        helpContent: helpContent,
                                        title: pageContext?.Title ?? '',
                                        trail: [{ label: formatMessage({ id: 'students.0933e5a0', defaultMessage: 'Students' }), to: '/students' }]
                                    }}
                                >
                                    <StudentProfile {...pageContext} setStudents={() => undefined} />
                                </PageWithHeader>
                            )
                        }
                    </div>
                </IntlProvider>
            </LocalizationProvider>
        </KendoIntlProvider>
    );

};
